<div class="map-external-container">
  <div id="map" class="map-container">
</div>
<div class="control-container">
  <details>
    <summary>Limites</summary>
    <label>
      <input
        type="checkbox"
        [checked]="isSubapVisible"
        (click)="applyFilter('bairros')"
      />
      Bairros
    </label>
  </details>
  <details>
    <summary>Transporte</summary>
    <label>
      <input
        type="checkbox"
        [checked]="isPMetroVisible"
        (click)="applyFilter('metro')"
      />
      Estações de Metrô
    </label>
    <label>
      <input
        type="checkbox"
        [checked]="isPOnibusVisible"
        (click)="applyFilter('onibus')"
      />
      Pontos de Ônibus
    </label>
    <label>
      <input
        type="checkbox"
        [checked]="isPTremVisible"
        (click)="applyFilter('trem')"
      />
      Estações de Trem
    </label>
  </details>
</div>
<div [ngStyle]="{'right': infoOpen ? '0' : '-100%'}"  class="information-container">
  <button (click)="infoOpen = false;" class="info-btn">X
  </button>
  <app-information [information]="information"></app-information>

</div>
</div>
